<script>
    export let 
        patientDetails = {},
        patientEncounterDetails = {};

    let errInputs = [];


    export const checkValidation = () => {
        errInputs = [];

        _updateInvalidFieldsStyle();

        return errInputs;
    };

    const _updateInvalidFieldsStyle = () => {
        
    };

</script>
<div class="flex-1 flex flex-col gap-2 pl-4 pr-4 w-full gap-y-2">
    <div class="flex-1 flex flex-col gap-2 gap-y-2">
        <div class="w-full flex flex-row gap-2">
            <div class="w-2/4 flex items-center">
                <p class="title">Procedure name:</p>
                <input
                    type="text"
                    id="procedureNameField"
                    placeholder="Procedure name"
                    class="input flex-1 input-sm input-bordered w-remaining"
                    autocomplete="off"
                    bind:value={patientEncounterDetails.procedureName}
                />
            </div>
             <div class="w-1/4 flex items-center">
                <p class="title">Start time:</p>
                <input
                    bind:value={patientEncounterDetails.scheduledTime}
                    type="time"
                    class="input flex-1 input-sm input-bordered col-span-1"
                    id="scheduledTimeField"
                />
            </div>
            <div class="w-1/4 flex items-center">
                <p class="title">UR Number:</p>
                <input
                    type="text"
                    id="URNumber"
                    class="input w-remaining input-sm input-bordered"
                    autocomplete="off"
                    placeholder="UR Number"
                    bind:value={patientDetails.urNumber}
                    on:focus={({ target }) => {
                        target.style.outline = "";
                        target.placeholder = "UR Number";
                    }}
                />
            </div>
        </div>
    </div>
</div>

<style>
    .title {
        width: 160px;
    }

    .w-remaining {
        width: calc(100% - 160px);
    }
</style>
